// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const faqHit = (item) => {
  return `
    <article class="pt-faq__question-item collapse__question-item g-col-12">
        <button class="pt-faq__question-item__button collapse__question-item__button" type="button">
            <span class="pt-faq__question-item__button-text collapse__question-item__button-text">${
              item._highlightResult.title.value
            }</span>
            <i class="pt-faq__question-item__icon collapse__question-item__icon vn-icons-arrow-down-circle"></i>
        </button>
        <div class="pt-faq__question-item__content collapse__question-item__content" style="display: none;">
          <div class="pt-faq__question-item__content-text collapse__question-item__content-text vn-content">${
            item.searchContent
          }</div>
          ${item.buttonHTML ? item.buttonHTML : ''}
        </div>
    </article>
  `
}

const faqButtun = {}
faqButtun.textContent = __('Load more questions', 'vn')

export { faqHit, faqButtun }
